import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-employee-notes',
  templateUrl: './employee-notes.component.html',
  styleUrls: ['./employee-notes.component.less']
})
export class EmployeeNotesComponent {
}
